import {
  DisplayType,
  FieldTypeEnum,
  KeyValueFormattingModel,
  KeyValueRestrictionModel,
} from '@models/module/fields/enums';
import { BaseFieldValueType } from '@models/module/fields/main';
import {
  CipoAttachmentConfig,
  CipoCheckboxConfig,
  CipoDateTimeConfig,
  CipoListConfig,
  CipoNumberConfig,
  CipoTextConfig,
} from '@shared/components/fields/common';

export type TableFieldRestriction = KeyValueRestrictionModel & { restrictionValue?: number };

export type TableFieldModel = {
  aggregate?: string;
  aggregateId?: number;
  canDelete: boolean;
  canHaveAggregate: boolean;
  canRemove: boolean;
  currentDateTime: boolean;
  dataSourceId?: number;
  displayType: DisplayType;
  entityIds: any[];
  expression?: string;
  fieldOrigin: number;
  formattings: KeyValueFormattingModel[];
  hasMultipleValues: boolean;
  id: number;
  inUse: boolean;
  isContractSystemField: boolean;
  isFilter: boolean;
  isRequired: boolean;
  isSystemField: boolean;
  label: string;
  maximumAllowedCharacters: number;
  name: string;
  parentChildLinkId: number;
  position: number;
  restrictions: TableFieldRestriction[];
  screenIds: any[];
  type: FieldTypeEnum;
  useOnReport: boolean;
  value?: BaseFieldValueType;
  width: number;
};

/** Union of all field configs that can be inside a table field */
export type CipoTableFieldsConfig = CipoTextConfig &
  CipoNumberConfig &
  CipoDateTimeConfig &
  CipoListConfig &
  CipoCheckboxConfig &
  CipoAttachmentConfig;

export type TableFieldConfig = CipoTableFieldsConfig &
  Pick<TableFieldModel, 'width' | 'name' | 'aggregateId'> & {
    /** this is the key used to identify the field in the table, in this case the id of the field as string */
    key: string;
    value?: BaseFieldValueType;
  };
